<template>
  <div>
    <div class="setUp"
         v-loading="loading">
      <div class="title"
           v-if="!showMail">{{$t('setting.phone_set')}}</div>
      <div class="title"
           v-if="showMail">{{$t('setting.mail_set')}}</div>
      <!-- <el-radio-group v-model="radio"
                      v-if="showMail"
                      style="margin-bottom: 10px"
                      size="small">
        <el-radio-button label="phone">手机</el-radio-button>
        <el-radio-button label="mail">邮箱</el-radio-button>
      </el-radio-group> -->
      <template v-if="radio == 'phone'">
        <div class="text">{{$t('setting.primary_number')}}：<span class="phone">{{mainPhone}}</span>{{$t('setting.note')}}：<span v-if="!showMainPhoneNoteInput">{{main_name}}</span>
          <i class="el-icon-edit-outline"
             v-if="!showMainPhoneNoteInput"
             style="margin:0 6px;"
             @click="phoneNoteEdit('main',{mainPhone:mainPhone})"></i>
          <el-input v-if="showMainPhoneNoteInput"
                    v-model="mainPhoneNote"
                    size="mini"
                    :placeholder="$t('setting.phone_placeholder')"
                    style="width:100px;margin:0 6px;"></el-input>
          <i class="el-icon-check"
             v-if="showMainPhoneNoteInput"
             @click="phoneNoteSub({name:mainPhoneNote,phone_id:main_phone_id})"></i>
          <i class="el-icon-close"
             v-if="showMainPhoneNoteInput"
             @click="showMainPhoneNoteInput = false"></i>
        </div>
        <div class="text">{{$t('setting.second_number')}} ：
          <div class="assistPhoneList-area">
            <div v-for="(item,index) in assistPhoneList"
                 :key="item.phone_id"
                 class="assistPhoneList">
              <span class="phone">{{item.phone}}</span> {{$t('setting.note')}}：<span v-if="!assistPhoneNoteArr.includes(item.phone_id)">{{item.name}}</span>
              <i class="el-icon-edit-outline"
                 v-if="!assistPhoneNoteArr.includes(item.phone_id)"
                 style="margin:0 6px;"
                 @click="phoneNoteEdit('assist',item)"></i>

              <el-input v-if="assistPhoneNoteArr.includes(item.phone_id)"
                        v-model="assistPhoneNoteList[index]"
                        size="mini"
                        :placeholder="$t('setting.phone_placeholder')"
                        style="width:100px;margin:0 6px;"></el-input>
              <i class="el-icon-check"
                 v-if="assistPhoneNoteArr.includes(item.phone_id)"
                 @click="phoneNoteSub({name:assistPhoneNoteList[index],phone_id:item.phone_id})"></i>
              <i class="el-icon-close"
                 v-if="assistPhoneNoteArr.includes(item.phone_id)"
                 @click="closeNoteEdit(item)"></i>
              <el-button class="sub"
                         type="danger"
                         size="mini"
                         @click="delPhone(item.phone_id)">{{$t('setting.delete')}}</el-button>
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="phoneNumBox">
            <el-input v-model="phoneNum"
                      size="mini"
                      onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                      :placeholder="$t('setting.phone_placeholder')"></el-input>
          </div>
          <div>
            <el-input :placeholder="$t('setting.optional')"
                      v-model="addPhoneNote"
                      size="mini"
                      style="width: 120px;margin-right: 10px"></el-input>
          </div>
          <div>
            <el-checkbox v-model="checked"
                         @change="isChecked">{{$t('setting.sms')}}</el-checkbox>
            <el-button class="sub"
                       type="primary"
                       size="mini"
                       @click="addPhone">{{$t('setting.add')}}</el-button>
          </div>
        </div>
        <div class="desc-area">
          <div>
            <span>{{$t('setting.desc')}}</span>
          </div>
          <div>
            <span>
              {{$t('setting.example')}}
            </span>
          </div>
        </div>
      </template>
      <template v-else-if="radio == 'mail'">
        <div class="text">{{$t('setting.mail_number')}} ：
          <div class="assistPhoneList-area">
            <div v-for="(item) in mailList"
                 :key="item.mail_id"
                 class="assistPhoneList">
              <span class="mail">{{item.mail}}</span>
              <span v-if="item.main"
                    class="mail-main-tag">{{$t('setting.primary_mail')}}</span>
              <el-button class="sub"
                         type="danger"
                         size="mini"
                         @click="delMail(item.mail_id)">{{$t('setting.delete')}}</el-button>
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="phoneNumBox">
            <el-input v-model="mailNum"
                      :placeholder="$t('setting.phone_placeholder')"></el-input>
          </div>
          <div>
            <!-- <el-checkbox v-model="checked"
                         @change="isChecked"></el-checkbox> -->
            <el-button class="sub"
                       type="primary"
                       size="mini"
                       @click="addMailFuc">{{$t('setting.add_mail')}}</el-button>
          </div>
        </div>
      </template>
    </div>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :append-to-body="true"
               :show-close="false"
               :visible="centerDialogVisible"
               width="288px"
               custom-class="successBox"
               center>
      <div style="text-align:center;">{{$t('setting.success')}}</div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="refresh">{{$t('setting.confirm')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible="phoneDialogVisible"
               width="288px"
               custom-class="phoneDialog"
               center>
      <div style="padding-left:24px;">{{$t('setting.dialog_phone')}}： {{mainPhone}}</div>
      <div class="codeBox">
        <div>
          <el-input class="code_input"
                    size="mini"
                    type="text"
                    v-model="code"
                    :placeholder="$t('setting.dialog_input_placeholder')"></el-input>
        </div>
        <el-button type="text"
                   :disabled="codeDisabled"
                   size="mini"
                   @click="getSmsCode">{{codeMsg}}</el-button>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="verification">{{$t('setting.verification')}}</el-button>
        <el-button size="mini"
                   @click="phoneDialogVisible = false">{{$t('setting.cancel')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible="mailDialogVisible"
               width="288px"
               custom-class="phoneDialog"
               center>
      <div style="padding-left:24px;">{{$t('setting.primary_mail')}}： {{ primaryMail.mail }}</div>
      <div class="codeBox">
        <div>
          <el-input class="code_input"
                    size="mini"
                    type="text"
                    v-model="mailCode"
                    :placeholder="$t('setting.dialog_input_placeholder')"></el-input>
        </div>
        <el-button type="text"
                   :disabled="mailCodeDisabled"
                   size="mini"
                   @click="getMailCode">{{mailCodeMsg}}</el-button>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="mailVerification">{{$t('setting.verification')}}</el-button>
        <el-button size="mini"
                   @click="mailDialogVisible = false">{{$t('setting.cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { computeIsMainMailLogin } from '../utils/mainMailLogin'

export default {
  props: {
    getPhone: {
      type: Function,
      required: true,
    },
    setPhone: {
      type: Function,
      required: true,
    },
    setPhoneNote: {
      type: Function,
      required: true,
    },
    deletePhone: {
      type: Function,
      required: true,
    },
    deleteMail: {
      type: Function,
      required: true,
    },
    getMail: {
      type: Function,
      required: true,
    },
    addMail: {
      type: Function,
      required: true,
    },
    smsSendSetting: {
      type: Function,
      required: true,
    },
    smsVerifySetting: {
      type: Function,
      required: true,
    },
    mailSendSetting: {
      type: Function,
      required: false,
      default: null,
    },
    mailVerifySetting: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      mainPhone: '',
      main_name: '', //主手机号的备注
      addPhoneNote: '',
      main_phone_id: '',
      assistPhone: '',
      assistPhoneList: [],
      assistPhoneNoteList: [],
      assistPhoneNoteArr: [],
      phoneNum: '',
      checked: true,
      centerDialogVisible: false,
      code: '',
      phone_id: '',
      phoneDialogVisible: false,
      codeDisabled: false,
      countdown: 60,
      codeMsg: '获取验证码',
      timer: null,
      mainPhoneNote: '',
      showMainPhoneNoteInput: false,
      // 邮箱
      radio: 'phone',
      mailList: [],
      mailNum: '',
      mail_id: '',
      showMail: false,
      pendingAction: null, // { type: 'addMail'|'delMail'|'addPhone'|'delPhone'|'phoneNote', payload?: any }
      isMainMailLogin: true,

      // 主邮箱验证码验证（用于邮箱增删门禁）
      mailDialogVisible: false,
      mailCode: '',
      mailCodeDisabled: false,
      mailCountdown: 60,
      mailCodeMsg: '获取验证码',
      mailTimer: null,
    }
  },
  computed: {
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
    /** 主邮箱：一次遍历得到 id / 脱敏展示 / 明文（若有） */
    primaryMail() {
      const list = this.mailList || []
      const m = list.find((x) => x && x.main === true) || null
      return {
        mail_id: m && m.mail_id != null ? String(m.mail_id) : '',
        mail: m && m.mail != null ? String(m.mail) : '',
        mail_raw: m && m.mail_raw != null ? String(m.mail_raw) : '',
      }
    },
  },
  methods: {
    syncMainMailLoginFlag() {
      this.isMainMailLogin = computeIsMainMailLogin(
        this.loginInfo || {},
        this.primaryMail
      )
    },
    requireSmsVerify(action) {
      // 邮箱登录模式可能没有主手机号：此时无法短信验证，避免弹窗卡死
      if (!this.main_phone_id || this.mainPhone == '') {
        this.$message.error(this.$t('setting.first_num'))
        return false
      }
      this.pendingAction = action || null
      this.phoneDialogVisible = true
      return true
    },
    requireMailVerify(action) {
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        return false
      }
      if (!this.mailSendSetting || !this.mailVerifySetting) {
        this.$message.error(this.$t('setting.mail_verify_api_missing'))
        return false
      }
      if (!this.primaryMail.mail_id) {
        this.$message.error(this.$t('setting.primary_mail_missing'))
        return false
      }
      this.pendingAction = action || null
      this.mailDialogVisible = true
      return true
    },
    apiErrorText(msg) {
      if (msg && typeof msg === 'object' && msg.msg) {
        return this.$i18n.locale === 'zh'
          ? msg.msg
          : msg.msg_en || msg.msg
      }
      return msg || ''
    },
    isChecked(val) {
      if (this.mainPhone == '') {
        this.checked = true
        this.$message.error(this.$t('setting.first_num'))
        return false
      }
    },
    addPhone() {
      if (this.phoneNum == '') {
        this.$message.error(this.$t('setting.enter_num'))
        return
      }
      //   if (!/^1[0-9]{10}$/.test(this.phoneNum)) {
      //     this.$message.error('请输入正确的手机号')
      //     return
      //   }
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting || this.mainPhone == '') {
        this.subPhone()
      } else {
        this.requireSmsVerify({ type: 'addPhone' })
      }
    },
    addMailFuc() {
      if (this.mailNum == '') {
        this.$message.error(this.$t('setting.enter_mail'))
        return
      }
      if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(this.mailNum)) {
        this.$message.error(this.$t('setting.enter_correct_mail'))
        return
      }
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        return
      }
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      // 无主邮箱时（首次添加）不做门禁，避免死锁；有主邮箱后增删必须先验证主邮箱
      if (hasVerifySetting || !this.primaryMail.mail_id) {
        this.subMail()
      } else {
        this.requireMailVerify({ type: 'addMail' })
      }
    },
    subMail() {
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        return
      }
      this.addMail({
        mail: this.mailNum,
      }).then((res) => {
        if (res.status == 'ok') {
          this.$message.success('修改成功')
          this.getPhoneData()
        } else {
          if (res.error_code === -498) {
            if (this.isMainMailLogin === false) {
              this.$message.error(this.$t('setting.main_mail_only_modify'))
              return
            }
            this.requireMailVerify({ type: 'addMail' })
            return
          }
          this.$message.error(this.apiErrorText(res.error_msg))
        }
      })
    },
    getPhoneData() {
      this.loading = true
      this.getMail()
        .then((res) => {
          this.loading = false
          const result = res.result
          const phone = result.phone
          const mail = result.mail
          // reset to avoid duplicated pushes on refresh
          this.assistPhoneNoteList = []
          if (phone && phone.length > 0) {
            let obj = phone.find((item) => {
              return item.main == true
            })
            if (obj) {
              this.mainPhone = obj.phone
              this.main_phone_id = obj.phone_id
              this.main_name = obj.name
            } else {
              this.mainPhone = ''
              this.main_phone_id = ''
              this.main_name = ''
            }
            let arr = phone.filter((item) => {
              return item.main != true
            })
            this.assistPhoneList = arr
            for (let i = 0; i < arr.length; i++) {
              this.assistPhoneNoteList.push(arr[i].name)
            }
          } else {
            this.mainPhone = ''
            this.main_phone_id = ''
            this.main_name = ''
            this.assistPhoneList = []
          }
          if (mail && mail.length > 0) {
            this.mailList = mail
          } else {
            this.mailList = []
          }
          this.syncMainMailLoginFlag()
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
          this.loading = false
        })
    },
    subPhone() {
      this.setPhone({
        phone: this.phoneNum,
        name: this.addPhoneNote,
        is_login_verify: this.checked + '',
        site_lang: this.$i18n.locale,
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (this.mainPhone != '') {
              //   this.assistPhoneList.push({
              //     phone: this.phoneNum,
              //     name: this.addPhoneNote,
              //     phone_id: res.result.phone_id,
              //   })
              this.getPhoneData()
            }
            this.centerDialogVisible = true
          } else {
            this.$message.error(res.error_msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
        })
    },
    delPhone(phone_id) {
      this.phone_id = phone_id
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting) {
        this.$confirm('确认删除?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
        })
          .then(() => {
            this.deletePhone({
              phone_id: phone_id,
            })
              .then((res) => {
                if (res.status == 'ok') {
                  this.assistPhoneList = this.assistPhoneList.filter((item) => {
                    return !phone_id.includes(item.phone_id)
                  })
                  this.$message.success('删除成功')
                } else {
                  this.$message.error(res.error_msg)
                }
              })
              .catch((e) => {
                this.$message.error(e.data.error_msg)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      } else {
        this.requireSmsVerify({ type: 'delPhone', payload: { phone_id } })
      }
    },
    delMail(mail_id) {
      this.mail_id = mail_id
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        return
      }
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting) {
        this.$confirm('确认删除?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
        })
          .then(() => {
            this.deleteMail({
              mail_id: mail_id,
            })
              .then((res) => {
                if (res.status == 'ok') {
                  this.mailList = this.mailList.filter((item) => {
                    return !mail_id.includes(item.mail_id)
                  })
                  this.$message.success('删除成功')
                } else {
                  if (res.error_code === -498) {
                    if (this.isMainMailLogin === false) {
                      this.$message.error(this.$t('setting.main_mail_only_modify'))
                      return
                    }
                    this.requireMailVerify({ type: 'delMail', payload: { mail_id } })
                    return
                  }
                  this.$message.error(this.apiErrorText(res.error_msg))
                }
              })
              .catch((e) => {
                this.$message.error(
                  this.apiErrorText(
                    e.data && e.data.error_msg ? e.data.error_msg : e.message
                  )
                )
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      } else {
        // 无主邮箱时不做门禁（与后端规则对齐：仅存在主邮箱才门禁）
        if (!this.primaryMail.mail_id) {
          this.$confirm('确认删除?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
          })
            .then(() => {
              this.deleteMail({ mail_id })
                .then((res) => {
                  if (res.status == 'ok') {
                    this.mailList = this.mailList.filter((item) => {
                      return !mail_id.includes(item.mail_id)
                    })
                    this.$message.success('删除成功')
                  } else {
                    this.$message.error(this.apiErrorText(res.error_msg))
                  }
                })
                .catch((e) => {
                  this.$message.error(
                    this.apiErrorText(
                      e.data && e.data.error_msg ? e.data.error_msg : e.message
                    )
                  )
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除',
              })
            })
          return
        }
        this.requireMailVerify({ type: 'delMail', payload: { mail_id } })
      }
    },
    getSmsCode() {
      if (!this.codeDisabled) {
        this.codeDisabled = true
        this.smsSendSetting({ phone_id: this.main_phone_id })
          .then((res) => {
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr()
              this.timer = setInterval(this.getValidStr, 1000)
            }
            if (res.status == 'ok') {
            } else {
              this.$message.warning(res.error_msg)
            }
          })
          .catch((e) => {
            this.codeDisabled = false
          })
          .finally(() => {})
      }
    },
    getValidStr() {
      if (this.countdown > 0 && this.countdown <= 60) {
        this.countdown--
        if (this.countdown !== 0) {
          this.codeMsg = this.countdown + 's'
        } else {
          clearInterval(this.timer)
          this.codeMsg = '获取验证码'
          this.countdown = 60
          this.timer = null
          this.codeDisabled = false
        }
      }
    },
    verification() {
      if (this.code == '') {
        this.$message.warning('请输入验证码')
        return
      }
      this.smsVerifySetting({ code: this.code, phone_id: this.main_phone_id })
        .then((res) => {
          if (res.status == 'ok') {
            this.phoneDialogVisible = false
            sessionStorage.setItem('hasVerifySetting', true)
            const action = this.pendingAction
            this.pendingAction = null
            // 自动续跑被 -498/弹窗拦下的操作
            if (action && action.type) {
              if (action.type === 'addMail' || action.type === 'delMail') {
                if (this.isMainMailLogin === false) {
                  this.$message.error(this.$t('setting.main_mail_only_modify'))
                  return
                }
              }
              if (action.type === 'addMail') {
                this.subMail()
              } else if (action.type === 'delMail') {
                if (action.payload && action.payload.mail_id) {
                  this.delMail(action.payload.mail_id)
                }
              } else if (action.type === 'addPhone') {
                this.subPhone()
              } else if (action.type === 'delPhone') {
                if (action.payload && action.payload.phone_id) {
                  this.delPhone(action.payload.phone_id)
                }
              }
            }
          }
        })
        .catch((e) => {
          const err = this.apiErrorText(
            e.data && e.data.error_msg ? e.data.error_msg : e.message
          )
          this.$message.error(err || '验证失败')
        })
    },

    getMailCode() {
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        return
      }
      if (!this.mailSendSetting) {
        return
      }
      if (!this.primaryMail.mail_id) {
        this.$message.error(this.$t('setting.primary_mail_missing'))
        return
      }
      if (!this.mailCodeDisabled) {
        this.mailCodeDisabled = true
        this.mailSendSetting({
          mail_id: this.primaryMail.mail_id,
          lang: this.$i18n.locale === 'zh' ? 'zh' : 'en',
        })
          .then((res) => {
            if (!this.mailTimer) {
              this.getMailValidStr()
              this.mailTimer = setInterval(this.getMailValidStr, 1000)
            }
            if (res.status !== 'ok') {
              this.$message.warning(this.apiErrorText(res.error_msg))
            }
          })
          .catch(() => {
            this.mailCodeDisabled = false
          })
      }
    },
    getMailValidStr() {
      if (this.mailCountdown > 0 && this.mailCountdown <= 60) {
        this.mailCountdown--
        if (this.mailCountdown !== 0) {
          this.mailCodeMsg = this.mailCountdown + 's'
        } else {
          clearInterval(this.mailTimer)
          this.mailCodeMsg = '获取验证码'
          this.mailCountdown = 60
          this.mailTimer = null
          this.mailCodeDisabled = false
        }
      }
    },
    mailVerification() {
      if (this.mailCode == '') {
        this.$message.warning('请输入验证码')
        return
      }
      if (this.isMainMailLogin === false) {
        this.$message.error(this.$t('setting.main_mail_only_modify'))
        this.mailDialogVisible = false
        return
      }
      if (!this.mailVerifySetting) {
        return
      }
      this.mailVerifySetting({ code: this.mailCode, mail_id: this.primaryMail.mail_id })
        .then((res) => {
          if (res.status == 'ok') {
            this.mailDialogVisible = false
            sessionStorage.setItem('hasVerifySetting', true)
            const action = this.pendingAction
            this.pendingAction = null
            if (action && action.type) {
              if (action.type === 'addMail') {
                this.subMail()
              } else if (action.type === 'delMail') {
                if (action.payload && action.payload.mail_id) {
                  this.delMail(action.payload.mail_id)
                }
              }
            }
          } else {
            this.$message.error(this.apiErrorText(res.error_msg) || '验证失败')
          }
        })
        .catch((e) => {
          const err = this.apiErrorText(
            e.data && e.data.error_msg ? e.data.error_msg : e.message
          )
          this.$message.error(err || '验证失败')
        })
    },
    refresh() {
      this.centerDialogVisible = false
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (!hasVerifySetting) {
        location.reload()
      }
    },
    phoneNoteEdit(typ, val) {
      // eslint-disable-next-line no-console
      console.log(typ, val)
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting) {
        if (typ == 'main') {
          this.mainPhoneNote = this.main_name
          this.showMainPhoneNoteInput = true
        } else if (typ == 'assist') {
          if (!this.assistPhoneNoteArr.includes(val.phone_id)) {
            this.assistPhoneNoteArr.push(val.phone_id)
          }
          const index = _.findIndex(this.assistPhoneList, function (o) {
            return o.phone_id == val.phone_id
          })
          if (index !== -1) {
            this.assistPhoneNoteList.splice(index, 1, val.name)
          }
        }
      } else {
        this.requireSmsVerify({ type: 'phoneNote', payload: { typ, val } })
      }
    },
    phoneNoteSub(val) {
      this.setPhoneNote({
        name: val.name,
        phone_id: val.phone_id,
        site_lang: this.$i18n.locale,
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (val.phone_id == this.main_phone_id) {
              this.showMainPhoneNoteInput = false
            } else {
              const index = this.assistPhoneNoteArr.indexOf(val.phone_id)
              if (index !== -1) {
                this.assistPhoneNoteArr.splice(index, 1)
              }
            }
            this.getPhoneData()
          } else {
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
        })
    },
    closeNoteEdit(val) {
      const index = this.assistPhoneNoteArr.indexOf(val.phone_id)
      if (index !== -1) {
        this.assistPhoneNoteArr.splice(index, 1)
      }
    },
  },
  created() {
    this.getPhoneData()
  },
  watch: {
    loginInfo: {
      handler(newVal) {
        if (newVal && newVal.use_mail) {
          if (newVal.use_mail) {
            this.radio = 'mail'
            this.showMail = true
          } else {
            this.radio = 'phone'
            this.showMail = false
          }
        }
        this.syncMainMailLoginFlag()
      },
      immediate: true,
    },
    mailList: {
      handler() {
        this.syncMainMailLoginFlag()
      },
      deep: true,
    },
  },
}
</script>
<style scoped lang='less'>
.views {
  /deep/ .phoneDialog {
    .codeBox {
      display: flex;
      margin-top: 10px;
      padding: 0 24px;
      .code_input {
        margin-right: 12px;
      }
    }
    .el-input__inner {
      width: 128px !important;
      height: 28px !important;
      border: 1px solid #ccc !important;
    }
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 24px 0 20px !important;
    }
    .el-dialog__footer {
      padding-bottom: 24px;
    }
  }
  /deep/ .successBox {
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 24px 0 55px !important;
    }
    .el-dialog__footer {
      padding-bottom: 24px;
    }
  }
}
.setUp {
  padding: 48px;
  width: 100%;
  height: 350px;
  // padding: 0 0 !important;
  box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
  border-radius: 4px 4px 4px 4px;
  background-color: white;
  font-family: sans-serif;
  color: #252525;
  .assistPhoneList-area {
    max-height: 80px;
    overflow-y: auto;
    width: 500px;
    .assistPhoneList {
      margin-bottom: 10px;
    }
  }
  .title {
    font-size: 16px;
    margin-bottom: 22px;
  }
  .text {
    font-size: 14px;
    margin-bottom: 12px;
    .phone {
      margin: 0 16px;
      vertical-align: middle;
    }
    .mail {
      margin-left: 16px;
      vertical-align: middle;
      width: 200px;
      display: inline-block;
    }
    .mail-main-tag {
      margin-left: 8px;
      font-size: 12px;
      color: #909399;
      vertical-align: middle;
    }
  }
  .inputBox {
    margin-top: 10px;
    display: flex;
    .phoneNumBox {
      margin-right: 18px;
      /deep/ input {
        width: 170px;
        height: 28px;
      }
    }
  }
  .desc-area {
    margin-top: 10px;
    color: #85868a;
    font-size: 12px;
  }
  .sub {
    margin-left: 28px;
  }
}
</style>